// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"8d10627e","683":"f43b2f1b","831":"6274a2cd"}[chunkId] + ".chunk.js";
};